import { List } from '../../constants-types/PiList.model';
import { BenchmarkProfile } from '../BenchmarkProfile.model';

export class JobReportInfo {
    id: string;
    jobTitle: string;
    jobDescription: string;
    aSigmaRangeLow: number;
    aSigmaRangeHigh: number;
    bSigmaRangeLow: number;
    bSigmaRangeHigh: number;
    cSigmaRangeLow: number;
    cSigmaRangeHigh: number;
    dSigmaRangeLow: number;
    dSigmaRangeHigh: number;
    matchingReferenceProfiles: BenchmarkProfile[];
    expectedBehaviors: string[];
    motivatingNeeds: string[];
    appealingWords: string[];
    primaryBehaviorTrait1: string;
    noteworthyBehaviors1: string[];
    primaryBehaviorTrait2: string;
    noteworthyBehaviors2: string[];
    cogScaledScore: number;
    cogWeight: number;
    hasCogAccess: boolean;
    reportCharacteristics: JobReportCharacteristic[];
    mainReportTexts: string[];
    reportAccompanyingTexts: Map<string, string>;

    constructor(startingValues?: Partial<JobReportInfo>) {
        // TODO this should probably be replaced by a factory
        Object.assign(this, startingValues);
    }
}

export class RefProfileReportInfo {
    patternNumber: number;
    name: string;
    singularName: string;
    pluralName: string;
    description: string;
    traits: List<string>;
    badgeUrl: string;
    challenges: List<string>;
    moreInfoLink: string;
    jobBadgeUrl?: string;

    constructor(options: Partial<RefProfileReportInfo>) {
        Object.assign(this, options);
    }
}

export class JobReportCharacteristic {
    headerText: string;
    characteristics: string[];

    constructor(options: Partial<JobReportCharacteristic>) {
        Object.assign(this, options);
    }
}
